import BaseComponent from '@/components/base';
import Style from '@/components/benefits-list/style';
import { FontStyle } from '@/components/style';

export default class BenefitsList extends BaseComponent {
  onConnect() {
    console.log(JSON.parse(this.getAttribute('items')));
  }

  render() {
    return `
      ${Style}
      ${FontStyle}
      <section class="benefits-list-module">
        <h3 class="benefits-list-module__title">${this.getAttribute(
          'title'
        )}</h3>
        <ul>
          ${JSON.parse(this.getAttribute('items'))
            .map((item) => {
              return `
              <li>
                <img src="${item.icon}" alt="${item.title} icon">
                <span>${item.title}</span>
              </li>`;
            })
            .join('')}
        </ul>
      </section>`;
  }
}
